import { Button, Flex, Text } from '@chakra-ui/react'
import { FC } from 'react'

interface IGridQuantity {
  data?: any[]
  isLoading?: boolean
  disabled?: boolean
  textButton?: string
  onClick?: () => void
}

const GridQuantityAlert: FC<IGridQuantity> = ({
  data,
  isLoading,
  disabled,
  textButton,
  onClick
}) => {
  const rowsDistinct = data
    .map(item => item['general-pedido'])
    .filter((value, index, self) => self.indexOf(value) === index)
  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      paddingRight={4}
      paddingLeft={3}
      paddingY={2}
    >
      <Text fontSize={14}>
        {' '}
        {rowsDistinct.length} Pedido(s) Encontrado(s), Total de: {data.length}{' '}
        produtos
      </Text>

      {textButton && (
        <Button
          fontSize={14}
          size="sm"
          color="#2F855A"
          borderRadius={5}
          border="1px solid #2F855A"
          cursor="pointer"
          isLoading={isLoading}
          disabled={disabled}
          transition="all ease .2s"
          _hover={{
            background: '#9AE6B4',
            color: '#1b4f35'
          }}
          onClick={onClick}
        >
          {textButton}
        </Button>
      )}
    </Flex>
  )
}

export default GridQuantityAlert
